import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDeletePracticeLanguages,
  fetchPracticeLanguages,
  fetchPracticeLanguageSuggestions,
} from "./PracticeLanguageAction";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const practiceLanguages = createSlice({
  name: "practiceLanguages",
  initialState: {
    isLanguageLoading: false,
    languageData: [],
    languageError: null,
    lngErrorMsg: null,
  },
  reducers: {
    addPracticeLanguage: (state, action) => {
      state.languageData = action.payload;
    },
    deletePracticeLanguage: (state, action) => {
      const { displayId } = action.payload;
      const updatedLanguages = action.payload.languageData.filter(
        (langItem) => {
          return langItem.displayId !== displayId;
        }
      );
      state.languageData = updatedLanguages;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPracticeLanguages.pending, (state) => {
        state.isLanguageLoading = true;
        state.languageError = null;
      })
      .addCase(fetchPracticeLanguages.fulfilled, (state, action) => {
        state.isLanguageLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.languageData = [];
            state.langError = false;
          } else {
            state.langError = true;
            state.lngErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.langError = false;
          state.languageData =
            action.payload.data.data.practiceLanguageResponseDTO;
        }
      })
      .addCase(fetchPracticeLanguages.rejected, (state, action) => {
        state.isLanguageLoading = false;
        state.languageError = action.error.message;
      });
    builder
      .addCase(fetchDeletePracticeLanguages.pending, (state) => {
        state.isLanguageLoading = true;
        state.languageError = null;
      })
      .addCase(fetchDeletePracticeLanguages.fulfilled, (state, action) => {
        state.isLanguageLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.languageData = [];
            state.langError = false;
          } else {
            state.langError = true;
            state.lngErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.langError = false;
          state.languageData =
            action.payload.data.data.practiceLanguageResponseDTO;
        }
      })
      .addCase(fetchDeletePracticeLanguages.rejected, (state, action) => {
        state.isLanguageLoading = false;
        state.languageError = action.error.message;
      });
  },
});

const practiceLanguageSuggestions = createSlice({
  name: "practiceLanguageSuggestions",
  initialState: {
    isLanguageSuggestionsLoading: false,
    languageSuggestionsData: [],
    languageSuggestionsError: null,
    languageSuggestionsErrorMsg: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPracticeLanguageSuggestions.pending, (state) => {
        state.isLanguageSuggestionsLoading = true;
        state.languageSuggestionsError = null;
      })
      .addCase(fetchPracticeLanguageSuggestions.fulfilled, (state, action) => {
        state.isLanguageLoading = false;
        if (action.payload.success) {
          state.languageSuggestionsError = false;
          state.languageSuggestionsData =
            action.payload.data.data.languageResponseDTO?.items;
        }
      })
      .addCase(fetchPracticeLanguageSuggestions.rejected, (state, action) => {
        state.isLanguageSuggestionsLoading = false;
        state.languageSuggestionsError = action.error.message;
      });
  },
});
export const { addPracticeLanguage, deletePracticeLanguage } =
  practiceLanguages.actions;
export const practiceLanguagesReducer = practiceLanguages.reducer;
export const practiceLanguageSuggestionsReducer =
  practiceLanguageSuggestions.reducer;
